import { render, staticRenderFns } from "./OpenRewardDialog.vue?vue&type=template&id=88ce6fb0&scoped=true"
import script from "./OpenRewardDialog.vue?vue&type=script&lang=js"
export * from "./OpenRewardDialog.vue?vue&type=script&lang=js"
import style0 from "./OpenRewardDialog.vue?vue&type=style&index=0&id=88ce6fb0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ce6fb0",
  null
  
)

export default component.exports